<div class="container-fluid">
    <h3 id="upper">Importation Pta</h3>
    <!-- <div class="card">

        <div class="container mt-5">

            <div class="row mb-3">
                <div class="col d-flex justify-content-center align-items-center">
                    <div class="d-flex align-items-center">
                        <label for="projet" class="me-2">Programmes:</label>
                        <select title="Veuillez sélectionner un Programmes" [(ngModel)]="projet" name="projet" class="form-control" id="projet" style="width: auto;">
                            <option *ngFor="let projet of projetsList" [ngValue]="projet">{{ projet.libelle }}</option>
                        </select>
                    </div>
                </div>
            </div>
        
            <div class="row mb-3">
                <div class="col d-flex justify-content-center align-items-center">
                    <div class="d-flex align-items-center me-3">
                        <label for="annee" class="me-2">Année:</label>
                        <input title="Veuillez renseigner l'année" [(ngModel)]="annee" name="annee" type="number"
                            class="form-control" id="annee" style="width: auto;" placeholder="Veuillez saisir l'année">
                    </div>
                
                    <div>
                        <input title="Veuillez sélectionner le fichier"
                            style="border-radius: 5px; border-color: #30489e; cursor: pointer; border-style: none;" type="file"
                            (change)="onFileSelected($event)" accept=".xlsx, .xls" class="form-control-file" #fileInput>
                    </div>
                </div>
            </div>
        
            <div class="row">
                <div class="col d-flex justify-content-center align-items-center">
                    <button title="Cliquez ici pour importer le fichier Excel" class="btn btn-success"
                        (click)="demarrerImportation()">
                        <i class="mdi mdi-cloud-upload me-2"></i> Importer
                    </button>
                </div>
            </div>

        </div>
        

        <br>


        <div class="d-flex justify-content-center" *ngIf="showInformation === false">
            <div class="container">
                <div class="row">
                    <div class="text-center">
                        <h4 class="text-success">Veuillez sélectionner un fichier pour voir les détails des PTA</h4>
                    </div>
                </div>
            </div>
        </div>

 -->

    <div class="container d-flex justify-content-center">
        <div class="card col-md-12 shadow">
            <div class="card-body text-center">
                <h5 class="card-title">Importez un fichier Excel</h5>

                <!-- Champs Année de début et Date d'adoption -->
                <div class="row mb-3 justify-content-center">
                    <div class="col-md-6">
                      <label for="anneeDebut">Année :</label>
                      <input disabled type="number" id="anneeDebut" class="form-control" style="background-color: rgb(211, 219, 206);" [(ngModel)]="annee" min="2000">
                    </div>
                  </div>
                  

                <!-- Zone Drag & Drop -->
                <div class="upload-container" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)">

                    <input type="file" #fileInput accept=".xls,.xlsx" (change)="onFileSelected($event)" hidden>

                    <div class="upload-box" (click)="triggerFileInput()">
                      <i class="pi pi-cloud-upload text-primary" style="font-size: 2rem"></i>
                        <p>Glissez-déposez un fichier ici ou cliquez pour importez un fichier Excel</p>
                    </div>
                </div>

                <!-- Fichier sélectionné -->
                <p *ngIf="fileName" class="mt-2 text-success">
                    <strong>Fichier sélectionné :</strong> {{ fileName }}
                </p>

                <!-- Bouton Envoyer -->
                <button class="btn btn-primary mt-3" (click)="demarrerImportation();"
                    [disabled]="!isSubmitted">Envoyer</button>
            </div>
        </div>
    </div>
    <div  class="container">

        <div class="container my-4" *ngIf="showInformation === true">
            <div class="row justify-content-center text-center">
              <div class="col-md-4">
                <div class="card shadow">
                  <div class="card-body">
                    <h5 class="card-title text-center">Activités</h5>
                    <p class="card-text">{{ excelData?.pta_activites?.length   || 0 }}</p>
                    <!-- Bouton Voir Plus -->
                    <div class="text-center mt-3">
                      <button class="btn btn-secondary" (click)="openModal(excelData?.pta_activites)">Voir Plus</button>
                    </div>
                  </div>
          
          
                </div>
              </div>
              <div class="col-md-4">
                <div class="card shadow">
                  <div class="card-body">
                    <h5 class="card-title text-center">Tâches</h5>
                    <p class="card-text">{{ excelData?.taches?.length  || 0  }}</p>
                    <div class="text-center mt-3">
                      <button class="btn btn-secondary" (click)="openModalTache(excelData?.taches)">Voir Plus</button>
                    </div>
                  </div>
          
                  <!-- Bouton Voir Plus -->
          
                </div>
              </div>
             
            </div>
          </div>
            <!-- Définition du modal avec ng-template -->
            <ng-template #sousActivitesModal let-modal> 
                <div class="modal-header">
                    <h5 class="modal-title text-center">Activités({{ excelData?.pta_activites.length}})</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body">
                    <table class="table table-bordered table-striped">
                        <thead class="text-center thead-light">
                          <tr>
                            <th>Code</th>
                            <th>Activité</th>
                            <th>Poids</th>
                            <th>État</th>
                            <th>Fonds Propres</th>
                            <th  style="white-space: nowrap;">PTF</th>
                            <th>Total</th>
                            <th>Struct. Resp</th>
                            <th>Structures associées</th>
                            <th>Localisation</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let act of paginatedProjets">
                            <td>{{ act.code_activite }}</td>
                            <td>{{ act.activite }}</td>
                            <td class="text-end">{{ act.poids }}</td>
                            <td style="white-space: nowrap;" class="text-end">{{ act.mt_financement_etat | formatMoney: null }}</td>
                            <td style="white-space: nowrap;" class="text-end">{{ act.mt_financement_fond_propre | formatMoney: null }}</td>
                            <td style="white-space: nowrap;"class="text-end">{{ act.mt_financement_ptf | formatMoney: null }}</td>
                            <td style="white-space: nowrap;"class="text-end">{{ act.total | formatMoney: null }}</td>
                            <td>{{ act.structure_responsable }}</td>
                            <td>{{ act.structures_associees }}</td>
                            <td>{{ act.localisation }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstActivite" [rows]="rowsActicite"
                      [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                  </p-paginator>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary"
                        (click)="modal.dismiss('Close click')">Fermer</button>
                </div>
            </ng-template>

            <ng-template #tacheModal let-modal>
                <div class="modal-header">
                    <h5 class="modal-title">Tâches ({{this.excelData?.taches.length}})</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body">
                    <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Code</th>
                            <th>Libellé</th>
                            <th>Date de début</th>
                            <th>Date de fin</th>
                            <th>Poids</th>
                            <th>Montant</th>
                            <th>Structure responsable</th>
                            <th>Structures associées</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let t of paginatedTache">
                            <td>{{ t.code }}</td>
                            <td>{{ t.libelle }}</td>
                            <td>{{ t.date_debut | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ t.date_fin | date: 'dd/MM/yyyy' }}</td>
                            <td class="text-end">{{ t.poids }}</td>
                            <td class="text-end">{{ t.montant_tache | formatMoney: null }}</td>
                            <td>{{ t.structure_responsable || '-' }}</td>
                            <td>{{ t.structures_associees || '-' }}</td>
                          </tr>
                        </tbody>
                      </table>
                      
                    <p-paginator (onPageChange)="onPageChangeTache($event)" [first]="firstTache" [rows]="rowsTache"
                        [totalRecords]="totalRecords2" [rowsPerPageOptions]="[10, 20, 30]">
                    </p-paginator>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary"
                        (click)="modal.dismiss('Close click')">Fermer</button>
                </div>
            </ng-template>

        </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<p-toast />